import axios from 'axios'
import { apiBaseUrl } from '../../../helpers/UrlHelper'
import { loginToken } from '../../../helpers/LocalStorageHelper'
import { handleError, handleSuccess } from '../../../helpers/ErrorHelper'

function _success(success) {
  return { type: 'CREATE_PRICE_SUCCESS', success }
}

function _error(error) {
  return { type: 'CREATE_PRICE_ERROR', error }
}

function _processing(processing) {
  return { type: 'CREATE_PRICE_PROCESSING', processing }
}

function createPrice() {
  return (dispatch,getState) => {

    let {priceForm} = getState();
    dispatch(_success(null))
    dispatch(_error(null))
    dispatch(_processing(true))

    axios({
      url: apiBaseUrl(`admin/global_prices`),
      method: 'post',
      dataType: 'json',
      data: priceForm.data.payload,
      headers: {
        'Authorization': 'Bearer ' + loginToken()
      }
    })
      .then(function(res) {
        dispatch(_success(res))
        dispatch(_processing(false))
        handleSuccess(res)
      }).catch(function(error) {
        dispatch(_error(error.response.data.message))
        dispatch(_processing(false))
        handleError(error)
      })
  }
}

export default createPrice
